import { Alert, TextLink } from '@/shared/components';
import type { TemplateSource } from '../types/documentTemplates.types';
import { provenanceLabel } from '../utils/templateOwnership';

interface Props {
  source: TemplateSource;
}

export function TemplateProvenanceBanner({ source }: Props) {
  return (
    <div className="space-y-2">
      <p className="text-sm text-mp-muted">
        {provenanceLabel(source)}{' '}
        <TextLink to={`/admin/document-templates/${source.templateId}`} color="primary" className="text-sm">
          View original
        </TextLink>
      </p>
      {source.newerVersionAvailable && (
        <Alert variant="info">
          <span>A newer version of the original template has been published since this was customised.</span>
        </Alert>
      )}
    </div>
  );
}
